import React, { useEffect, useState } from "react";
import FormleftNev from "../../../components/common/FormleftNev"
import FormnavBar from "../../../components/common/wizard_navbar";
import Lang from "../../../lang";
import TlkTable from "../../../components/tlelrik/table/tlkTable";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Switch } from "@progress/kendo-react-inputs";
import { Tooltip } from "antd";
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import queryString from "query-string";
import services from "../../../services";
import { toast } from "react-toastify";
import $ from "jquery";
import jsPDF from "jspdf";
import "@patternfly/react-core/dist/styles/base.css";
import { DualListSelector } from '@patternfly/react-core';
import EntityDetails from '../../../components/common/EntityDetails';
import SearchFilter from '../../../components/filters/SearchFilter';
import { Select } from 'antd';
import CriacaoFatura from "./CriacaoFatura";
import { insertItem, getItems, updateItem, deleteItem } from "./services";
import TablePreenchida from "./TablePreenchida";
import { Document, Page } from 'react-pdf';

const { Option } = Select

//import lang from "../../../lang";
//import LabelTabel from "./LabelTable.jsx";
var moment = require("moment");

const dateFormat = "YYYY-MM-DD";
const dateShowFormat = "dd/MM/yyyy";
let listdefaultRequest = { Filters: null, "SortBy": "id", "IsSortTypeDESC": true, "IsPagination": true, "Page": 1, "PageSize": 100 }
let imageObj =
    "data:image/png;base64,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";

let InputFieldsAll = {
    ClienteReceita:[],
    DetalhesFatura: [],
    LinhasFatura: [],
    ObservacoesFatura: [],
    FaturaPDF: []
};
var DisableByDetail = false;
const columnKeyMap = {
    numeroPedido: "Número de Pedido",
    numeroRegistoOrigem: "Número Registo Origem",
    numeroRegistoDestino: "Número Registo Destino",
    correlativas: "Correlativas"
}
var ivaDet = 0
var valorDet = 0
var applyedfilterFiltro;
var EntidadeArray = 0;



class CriacaoReceita extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            linkData: {
                filters:[] 
            },
            availableOptions: ['Option 1', 'Option 2', 'Option 3', 'Option 4'],
            chosenOptions: [],
            certProcIVDest: [],
            finalDataArray: [],
            show: false,
            isRemarkSet: false,
            mandatoryMissing: false,
            headName: "Gerar Documento",
            sendData: {
                processomento: {
                    pmentos: [],
                },
                processo: {
                    bib: false,
                    seloIncorporado: false,
                    logo: false,
                    macrapropria: false,
                },
                Dataatual: new Date(),
                Ultimaobservacao: "",
                aprovodo: true,
            },
            filtersEnt: {
                Filters: { entityId: null },
                FiltersIn: null,
                FiltersLike: null,
                SortBy: "",
                IsSortTypeDESC: false,
                IsPagination: true,
                Page: 2,
                PageSize: 20,
              },
            // readOnly : false,
            readOnly: true,
            parsed: {},
            telkikTable: "",
            entityGrid: "",
            tituloList: [],
            processoTelkikTable: "",
            applyedfilter: {},
            resData: {},
            registoData: {},
            operation: {
                IDEntidadeDestino: 0,
              },
            filterData: [
                {
                    "Nº Registo": "a",
                    Produto: "a",
                    Cor: "a",
                    Álcool: "a",
                    Tipo: "a",
                    Ano: "a",
                    Doçura: "a",
                    "Acidez (%)": "a",
                    "Saldo Incial (Lts)": "a",
                    Madeira: "a",
                    "Velor energetico": "Velor energetico",
                    Carbohydratos: "Carbohydratos",
                    Proteinas: "Proteinas",
                    "Fibra Elimentor": "Fibra Elimentor",
                    Sodio: "Sodio",
                    "Rotulus aprovados": "xxxxx",
                },
            ],
            nullProcess: true,
            invoice: null
        };
        this.onListChange = (newAvailableOptions, newChosenOptions) => {
            this.setState({
              availableOptions: newAvailableOptions.sort(),
              chosenOptions: newChosenOptions.sort()
            });
        };
    }
    createState = () => {
        if (this.props.linkData && this.props.linkData.columnkeyMap) {
            let columnkeyMap = this.props.linkData.columnkeyMap;
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
            });
            this.setState({
                columnlist,
                tabsComponentsView: null,
                Tab: this.props.Tab,
                entity_details: this.props.entity_details,
                currency_list: this.props.entity_details,
                tax_list: this.props.entity_details,
                TransMethods_list: this.props.entity_details,
                CalculationTabs: null,
                filters: this.props.linkData.filters
            }, () => {
                if (!this.props.singleentity) {
                    this.getListData();
                }
                this.tabsCalculation()
                this.tabSectionView()
            })
        }
    }
    

    redirectScreen = () => {
        let paramoption = {};
        let url = "/revenue_receitas";
        if (this.state.parsed.from === "rotulos") {
            url = "/revenue_receitas";
            if (this.state.parsed.evaluator == 1) {
                paramoption = {
                    name: "1ª avaliação",
                    url: "/revenue_receitas",
                    tableName: "RotulosOneAvalicao",
                };
            } else if (this.state.parsed.evaluator == 2) {
                paramoption = {
                    name: "2ª avaliação",
                    url: "/revenue_receitas",
                    tableName: "RotulosTwoAvalicao",
                };
            } else {
                paramoption = {
                    name: "Pendentes",
                    url: "/revenue_receitas",
                    tableName: "RotulosPendentes",
                };
            }
        } else if (this.state.parsed.from === "minhas_avaliações") {
            url = "/revenue_receitas";
            paramoption = {
                name: "Minhas avaliações",
                url: "/revenue_receitas",
                tableName: "minhas_avaliações",
            };
        }

        this.props.history.push({
            pathname: url || "/revenue_receitas",
           
        });
    };

    handlePopUpsubmit = (data) => {
        let { finalDataArray } = this.state;
        // finalDataArray=[...finalDataArray,data];
        finalDataArray = [
            ...finalDataArray,
            { discritivo: data.discritivo, titulo: data.id },
        ];
        let tableRowData = { ...data };
        let newData = { ...this.state.sendData };
        newData["processomento"] = { ...newData.processomento };
        newData["processomento"]["pmentos"] = [
            ...newData.processomento.pmentos,
            tableRowData,
        ];
        this.setState(
            {
                sendData: newData,
                show: false,
                finalDataArray,
            },
            () =>
                this.createTabel(
                    "processomento",
                    this.state.sendData.processomento.pmentos
                )
        );
    };

    createPDF = (type) => {
        var doc = new jsPDF("p", "pt", "a4");
        if (type === "Outros Formatos") {
            this.state.resData.imagens &&
                this.state.resData.imagens.map((imageData, i) => {
                    doc.addImage(imageObj, "PNG", 150, 100, 350, 150);
                    if (i < this.state.resData.imagens.length - 1) {
                        doc.addPage();
                    }
                });
            doc.save(type);
        } else if (type === "document") {
            let image =
                this.state.resData &&
                this.state.resData.características_do_rotulo &&
                this.state.resData.características_do_rotulo
                    .documentodecedencia; // use this code but it break so commented for now
            // let image = imageObj
            // doc.addImage(image, 'PNG', 150, 100, 350, 150);
            console.log("image", image);
            var a = document.createElement("a"); //Create <a>
            a.href = "data:image/png;base64," + image; //Image Base64 Goes here
            a.download = "Image.png"; //File name Here
            a.click();
        }
    };
   
    handleSubmit = async () => {
        const originalItem = getItems();
        console.log("CENASSSSS" , originalItem)

        let query = queryString.parse(window.location.search)
       
        if($(".ant-select-selection-item").length == 0){
            $(".DropEntidade").css("border" ,"1px solid red")
        }else{
            $(".DropEntidade").css("border" ,"1px solid grey")
        }
        if($("#TipoDocumento :selected").val() == "0"){
            $("#TipoDocumento").css("border" ,"1px solid red")
        }else{
            $("#TipoDocumento").css("border" ,"1px solid #ccc")
        }
        if($("#TipoPagamento :selected").val() == "0"){
            $("#TipoPagamento").css("border" ,"1px solid red")
        }else{
            $("#TipoPagamento").css("border" ,"1px solid #ccc")
        }
        if(originalItem.length == 0){
            $(".k-grid-container").css("border" ,"1px solid red")
        }else{
            $(".k-grid-container").css("border" ,"1px solid #00000014")
        }
        if($(".ant-select-selection-item").length != 0 && $("#TipoDocumento :selected").val() != "0" && $("#TipoPagamento :selected").val() != "0" && originalItem.length != 0){
            var artigosFatura = [];

            for (let index = 0; index < originalItem.length; index++) {
                var idArtigo = originalItem[index].idArtigo.value;
                idArtigo = parseInt(idArtigo.split("!")[1])
                var linha = originalItem[index].ProductID;
                var descricaoTeste = originalItem[index].idArtigo.descricao;
                var quantidade = parseInt(originalItem[index].quantidade.replace(/\./g, '').replace(/\,/g, '.'));
                var valorUnitariotext = originalItem[index].ValorUnitario
                // valorUnitariotext.replace("€" , "");
                var valorUnitario = parseFloat(valorUnitariotext.replace(/\./g, '').replace(/\,/g, '.'));
                var valor = parseFloat(originalItem[index].valor.replace(/\./g, '').replace(/\,/g, '.'))
    
                artigosFatura.push({"idArtigo" : idArtigo,
                                    "linha": linha,
                                    "descricao":descricaoTeste,
                                    "quantidade": quantidade,
                                    "valorUnitario": valorUnitario,
                                    "valor": valor
                                })
                }
    
                var idEntidade = EntidadeArray
                var idTipoFatura = parseInt($("#TipoDocumento :selected").val())
                var idTipoPagamento =  parseInt($("#TipoPagamento :selected").val())
                var descricao = $(".DescricaoObs").val()
                var TotalTotal =  $(".totalReceita").text()
                var TotalTotaltext = TotalTotal.replace("€" , "");
                var TotalTotalNumber = parseFloat(TotalTotal.replace(/\./g, '').replace(/\,/g, '.'))
                let data = {
                    idEntidade: idEntidade,
                    idTipoFatura: idTipoFatura,
                    idTipoPagamento: idTipoPagamento,
                    descricao: descricao,
                    numeroCompromisso: "",
                    referencia: "",
                    valorTotal: TotalTotalNumber,
                    motivoNC: "",
                    dataFaturacao: "",
                    dataEntrega: $(".date_emissao_receita input").val(),
                    dataPagamento: $(".date_limite_receita input").val(),
                    LoggedUser: window.localStorage.getItem('username'),
                    artigos: artigosFatura,
                    idAuto: +query.idAuto ? query.idAuto : null
                };
                
                let res = await services.apiCall.requestApi(
                    "/Receita/SubmeterDocumento",
                    data,
                    "post"
                );
                if (res) {
                    this.redirectScreen();
                }
        }
        
        
    };

    ActionPerform = () => { };

    columnlist = Object.keys(columnKeyMap).map(function (key) {
        return { field: columnKeyMap[key], columnMenuType: "checkbox" };
    });
    searchEntidade = (e) => {
        console.log("hey");
        console.log(e);
        let entidades = []
        
        if (e == ""){
          return;
        }
    
        const filters = {"Nome" : e , "NIF" : e};
        
        (async () => {
            var Validanumero = /^\d+$/.test(e)
            if(Validanumero == false){
                const filters = {
                    "Nome" : e 
                };
                entidades = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    filters,
                    "get"
                );
            }else{
                const filters = {
                    "NIF" : e,
                };
                entidades = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    filters,
                    "get"
                );
            }
            
    
            this.setState({ entidades })
            // entidades.map((entidade) => (
            //   console.log({value: entidade.codEntidade, label: entidade.nome})
            // ));
        })()
    }

    createTabel = (module, data) => {
        console.log("800 in the data ", data);
        console.log("800 in the column list", this.columnlist);

        const columnList = Object.keys(columnKeyMap).map((key) => ({
            field: columnKeyMap[key],
            columnMenuType: "checkbox",
        }))

        if (module === "registo") {
            let telkikTable = (
                <TlkTable
                    notGroup={true}
                    noDownloadButton={true}
                    pageable={false}
                    date={new Date()}
                    notAction={true}
                    forRutoloDetail={true}
                    viewFor={"rotulos"}
                    noFilterShow={true}
                    modulename={"rotulos"}
                    deleteFunc={(id) => this.handleDelete(id)}
                    list={data}
                    columnlist={columnList}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                />
            );

            this.setState({ telkikTable });
        }
    };

    isRemarkSet = () => {
        this.setState({
            isRemarkSet: true,
        });
    };

    

    componentDidMount() {
        CriacaoFatura.removeAllrows()
        // const reloadCount = sessionStorage.getItem('reloadCount');
        // if(reloadCount < 2) {
        //   sessionStorage.setItem('reloadCount', String(reloadCount + 1));
        //   window.location.reload();
        // } else {
        //   sessionStorage.removeItem('reloadCount');
        // }
      
        //$(window).scrollTop(0);
        DisableByDetail = false;
        //this.getTituloList();
        let parsed = queryString.parse(window.location.search);
        console.log("parsed in mount", parsed);
        console.log("PROPS: ", this.props);
        const queryParams = queryString.parse(window.location.search)
        const token = queryParams.idFatura
        console.log(token ,"QUERY")

        this.setState(
            {
                parsed,
                readOnly: parsed.evaluator ? false : true,
                estado: parsed.estado,
                data:[]
            },

            () => {
                if (parsed.idPedidoTransferencia) {
                    this.getTipoDocumento(parsed.idPedidoTransferencia);
                }
            }
        );
        
        (async () => {
            const data = {}
                const TipoDocumento = await services.apiCall.requestApi(
                   "/Receita/GetTipoFatura",
                   data,
                   "get"
                );
                
                var strHTML = "<option value='0' selected>Selecione...</option>";
                for (let index = 0; index < TipoDocumento.length; index++) {
                  var idTipoFatura = TipoDocumento[index].idTipoFatura;
                  var descricao = TipoDocumento[index].descricao;
                strHTML = strHTML + "<option value='" + idTipoFatura + "'>" + descricao + "</option>";
                }  
                $("#TipoDocumento").html(strHTML);

                const datapagamento = {}
                const TipoPagamento = await services.apiCall.requestApi(
                   "/Receita/GetTipoPagamento",
                   datapagamento,
                   "get"
                );
                
                var strHTML = "<option value='0' selected>Selecione...</option>";
                for (let index = 0; index < TipoPagamento.length; index++) {
                  var idTipoPagamento = TipoPagamento[index].idTipoPagamento;
                  var descricao = TipoPagamento[index].descricao;
                strHTML = strHTML + "<option value='" + idTipoPagamento + "'>" + descricao + "</option>";
                }  
                $("#TipoPagamento").html(strHTML);
                
                const dataEntidade = {}
                var strHTML = "<option value='0' selected>Selecione...</option>";
                const TipoEntidade = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    dataEntidade,
                    "get"
                );
                TipoEntidade.map((TipoEntidade) => (
                    strHTML = strHTML + "<option value='" + TipoEntidade.codEntidade + "'>" + TipoEntidade.nome + "</option>"
                ));

                $("#TipoEntidade").html(strHTML);
               
                console.log("this.props.location.search: ", window.location.search);
               if(window.location.search != "" && !window.location.search.includes("Auto")){

                if(window.location.search != ""){
                    if(token){
                        const dataToken = {"idFatura": token}
                        var Detalhes = await services.apiCall.requestApi(
                           "/Receita/GetFaturaDetalhe",
                           dataToken,
                           "get"
                        );
                    }
                   
                    if(Detalhes){
                        var TipoDocId = Detalhes.idTipoFatura
                        $("#TipoDocumento option[value='" + TipoDocId + "']").attr("selected","selected");
                        $("#TipoDocumento").prop('disabled', true);
    
                        var TipoPagId = Detalhes.idTipoPagamento
                        $("#TipoPagamento option[value='" + TipoPagId + "']").attr("selected","selected");
                        $("#TipoPagamento").prop('disabled', true);
    
                        $("ul.navbar-nav").css("display", "none")
    
                        var dataPagamento = Detalhes.dataPagamento
                        var dc = new Date(dataPagamento);
                        var dFormatC = (dc.getDate()) + "/" + (dc.getMonth()) + "/" + (dc.getFullYear()) ;
                        //dataPagamento = dataPagamento.toLocaleDateString("en-US")
                        $("#date_limite_receita").val(dFormatC)
                        //$("#date_limite_receita").prop('disabled', true);
                        document.getElementById("date_limite_receita").disabled = true;
    
                        var dataEntrega = Detalhes.dataEntrega
                        var dce = new Date(dataEntrega);
                        var dFormatCE = (dce.getDate()) + "/" + (dce.getMonth()) + "/" + (dce.getFullYear()) ;
                        //dataPagamento = dataPagamento.toLocaleDateString("en-US")
                        $("#date_emissao_receita").val(dFormatCE)
                        $("#date_emissao_receita").prop('disabled', true);
                        $("#date_limite_receita").css("padding-top" , "18px")
                        $(".DescricaoObs").val(Detalhes.descricao)
                        $(".DescricaoObs").text(Detalhes.descricao)
                        $(".DescricaoObs").prop('disabled', true);
                        $("#emptyGrid").css("display" , "none")
                        DisableByDetail = true
                        var entidade = Detalhes.entidade
                        $("#entidadeNameDetails").text(entidade)
                        $("#entidadeNameDetails").val(entidade)
                        $("#SearchEntidadeBox").css("display" , "none")
                        var ivaDet = 0
                        var valorDet = 0
                        /* contas do card */
                        for (let index = 0; index < Detalhes.artigos.length; index++) {
                            const ivaDetalhe = Detalhes.artigos[index].iva;
                            var valorDetalhe = Detalhes.artigos[index].valor;
    
                            ivaDet += (valorDetalhe * ivaDetalhe)/100;
                            valorDet += valorDetalhe;
    
                            var primeiraCaixa = valorDet.toFixed(2);
                            var SegundaCaixa = ivaDet.toFixed(2);
                            var terceiraCaixa = parseFloat(primeiraCaixa) + parseFloat(SegundaCaixa)
                            terceiraCaixa = terceiraCaixa.toFixed(2)
                            primeiraCaixa = String(primeiraCaixa).replace(".", ",")
                            SegundaCaixa = String(SegundaCaixa).replace(".", ",")
                            terceiraCaixa = String(terceiraCaixa).replace(".", ",")
                            $(".Subtotal").text(primeiraCaixa + "€");  
                            $(".IvaReceita").text(SegundaCaixa + "€"); 
                            $(".totalReceita").text(terceiraCaixa + "€"); 
    
                          
                        }
    
                        /* Load PDF */
                        this.setState({ invoice: Detalhes.pdf });
    
                        if (Detalhes.pdf === "") {
                            $("#FaturaPDF").css("display" , "none")
                        }
                        else{
                            $("#FaturaPDF").css("display" , "block")
                        }
                    }
                    

                }else{
                    $("#fillGrid").css("display" , "none")
                    $("#EntidadeDiv").css("display" , "none")
                    $("#FaturaPDF").css("display" , "none")
                }
            }else{
                $("#fillGrid").css("display" , "none")
                $("#EntidadeDiv").css("display" , "none")
                $("#FaturaPDF").css("display" , "none")
            }
         })();
                
    }
     /*Para obter detalhes de uma única entidade usando api */

/////// preenche a drop do tipo de auto ////
handleChangeEntidade = (e) => {
EntidadeArray = e;
this.setState({ operation: {...this.state.operation.IDEntidadeDestino = e } });
console.log("ENTIDADEEEEE" , this.state.operation.IDEntidadeDestino)
//     let applyedfilter = e
//     this.setState({
//         applyedfilter,
//         date:new Date()
//     },
//    // applyedfilterFiltro = applyedfilter.entityIdFilter,
//     console.log("ENTIDADEEEEE" , this.state.applyedfilter)
//     )
  }
getTipoDocumento() {
    (async () => {
  
    const data = {}
            const TipoDocumento = await services.apiCall.requestApi(
               "/Receita/GetTipoFatura",
               data,
               "get"
            );
            
            var strHTML = "<option value='0' selected>Selecione...</option>";
            for (let index = 0; index < TipoDocumento.length; index++) {
              var idTipoFatura = TipoDocumento[index].idTipoFatura;
              var descricao = TipoDocumento[index].descricao;
            strHTML = strHTML + "<option value='" + idTipoFatura + "'>" + descricao + "</option>";
            }  
            $("#TipoDocumento").html(strHTML);
        })();
}

/////// end preenche a drop das familias ////

    componentDidUpdate(preprops) { }
    
    
    handleFilter = (data) => {
        console.log("ENTIDADEEEEEEEEEEE" , data)
        // this.setState({
        //     filterData: data
        // }, () => this.createTabel())
    }
    getFilters = (customfilters) => {
        let applyedfilter = { ...customfilters.filterCheckbox, ...customfilters.filters }
        delete applyedfilter.entity;
        applyedfilter.local = window.localStorage.getItem('Local');
        console.log("filter", applyedfilter);
        applyedfilter = applyedfilter.entityIdFilter
        this.setState({
            applyedfilter,
            date:new Date()
        },
       // applyedfilterFiltro = applyedfilter.entityIdFilter,
        console.log("ENTIDADEEEEE" , this.state.applyedfilter)
        );
    }

    getTableDate = (type, data) => {
        console.log("data 123: ", data)
        if (type === "Processamento") {
            Object.keys(columnKeyMap).map((key) => {
                console.log(key,"key")
                console.log(columnKeyMap[key],"key2")
                 data.map((el) => {
                     console.log(el)
                    if (key === "numeroPedido") {
                        el[columnKeyMap[key]] = el.numeroPedido;
                    } 
                    else if (key === "numeroRegistoOrigem") {
                        el[columnKeyMap[key]] = el.numeroRegistoOrigem;
                    } 
                    else if (key === "numeroRegistoDestino") {
                        el[columnKeyMap[key]] = el.numeroRegistoDestino;
                    } 
                    else if (key === "correlativas") {
                        el[columnKeyMap[key]] = el.correlativas;
                    } 
                });
            });
        }
    };

    formatTableData = (data) => {
        console.log("formatTableData: ", data)
        return data.map((_row, index) => {
            Object.keys(_row).map(function (key) {
                if (key === "indiceCalorico") {
                    Object.keys(_row[key]).map((_k) => {
                        _row[Lang.langCheck.langRequest(_k)] = _row[key][_k];
                    });
                } else {
                    _row[Lang.langCheck.langRequest(key)] = _row[key];
                }
            });
        });
    };

    createTable = async (type, data) => {
        const columnlist = Object.keys(columnKeyMap).map(function (key) {
            return { field: columnKeyMap[key], columnMenuType: "checkbox" };
        });

        console.log("columnlist", columnlist);
        console.log("data", data);


        let telkikTable = (
            <TlkTable
                notGroup={true}
                noDownloadButton={true}
                pageable={false}
                date={new Date()}
                notAction={true}
                viewFor="marcas"
                forRutoloDetail={true}
                noFilterShow={true}
                modulename="marcas"
                deleteFunc={(id) => this.handleDelete(id)}
                list={data}
                columnlist={columnlist}
                ActionPerform={(action, id) =>
                    this.ActionPerform(action, id)
                }
            />
        );

        this.setState({ telkikTable });
    }

    returntoFirst = async (obs) => {
        let data = {
            VoltarDoSegundo: true,
            Nprocesso: +this.state.parsed.id,
            Ultimaobservacao: obs,
            NumeroAvaliacao: 2,
            processmentos: {
                Pmentos: [],
            },
        };

        let res = await services.apiCall.requestApi(
            "/SIVDP/evelution_approvel_next_lavel",
            data,
            "post"
        );
        if (res) {
            $("#popup-return").trigger("click");
           
            this.props.history.push({
                pathname: "/revenue_receitas",
                //state: { paramoption: paramoption },
            });
        }
    };

    handleLibertar = async () => {
        let res = await services.apiCall.requestApi(
            "/SIVDP/libertar",
            { id: +this.state.parsed.id },
            "post"
        );

        if (res) {
            let paramoption = {
                name: "Pendentes",
                url: "/revenue_receitas",
                tableName: "RotulosPendentes",
            };
            this.props.history.push({
                pathname: "/revenue_receitas",
                state: { paramoption: paramoption },
            });
        }
    };

    handleChange = (e, type) => {
        console.log("eleeee", e.target.value);
        let sendData = { ...this.state.sendData };
        if (type === "processoLabel") {
            sendData["processo"] = { ...sendData.processo };
            sendData["processo"][e.target.name] = e.target.checked;
        } else {
            // sendData['processomento'] = {...sendData.processomento}
            sendData[e.target.name] =
                type === "date"
                    ? services.Converter.dateConvert(e.target.value, dateFormat)
                    : e.target.value;
        }

        this.setState({ sendData });
    };
    //// grid
    displayPDF(e) {
        e.preventDefault();
        //The PDFContent bytes are mapped to an input element called pdfString
        // if($('#pdfString').val() == '')
        //     return;
        var file = this.b64toBlob(this.state.invoice, 'application/pdf');
        //If the browser is IE or Edge
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
        }
        else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        }
    }

    b64toBlob(b64Data, contentType, sliceSize) {
          contentType = contentType || '';
          sliceSize = sliceSize || 512;

          var byteCharacters = atob(b64Data);
          var byteArrays = [];

          for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
          }

          var blob = new Blob(byteArrays, {type: contentType});
          return blob;
    }
    
    

    render() {
        // console.log("data",this.state.sendData, this.state.resData)
        console.log("submetidopor:");
        console.log(this.state);

        if (this.state.invoice === null || this.state.invoice === ""){
            InputFieldsAll = {
                ClienteReceita:[],
                DetalhesFatura: [],
                LinhasFatura: [],
                ObservacoesFatura: []
            };
        } 
        else{
            InputFieldsAll = {
                ClienteReceita:[],
                DetalhesFatura: [],
                LinhasFatura: [],
                ObservacoesFatura: [],
                FaturaPDF: []
            };
        }

        let leftNavFields = {ClienteReceita: [], ...InputFieldsAll };
        let parsed = queryString.parse(window.location.search);
        let estadoQuery = parsed.estado;
        let processmentoLabel = this.state.resData.processmentos || {};
        let processoLabel =
            (this.state.resData && this.state.resData.processo) || {};
        console.log(processoLabel);
        return (
            <div className="dashboard">
                {estadoQuery != null ?(
                    <>
                    <FormnavBar
                        showReturnButton={
                            this.state.resData.evaluationStatus !== "under_review1"
                        }
                        pendingCases={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                        
                        handleLibertar={() => this.handleLibertar()}
                       
                        to={"/" + (this.state.parsed.from || "rotulos")}
                       handleSubmit={(data, url) => this.handleSubmit(data, url)}
                        returntoFirst={(data) => this.returntoFirst(data)}
                        estado={this.state.resData.estado}
                        numeroAvaliacao={this.state.resData.numeroAvaliacao}
                        parsed={this.state.parsed}
                        type="parcelas"
                        headName="Trasf"
                        evaluator={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                    />
                    </>
                ):(
                    <>
                    <FormnavBar
                        showReturnButton={
                            this.state.resData.evaluationStatus !== "under_review1"
                        }
                        pendingCases={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                        
                        handleLibertar={() => this.handleLibertar()}
                       
                        to={"/" + (this.state.parsed.from || "revenue_receitas")}
                        handleSubmit={(data, url) => this.handleSubmit(data, url)}
                        returntoFirst={(data) => this.returntoFirst(data)}
                        estado={this.state.resData.estado}
                        numeroAvaliacao={this.state.resData.numeroAvaliacao}
                        parsed={this.state.parsed}
                        type="parcelas"
                        headName={this.state.headName}
                        evaluator={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                    />
                    </>
                )}
               
                <div className="full-container edit-ward">
                    <FormleftNev
                        InputFieldsAll={leftNavFields}
                        navFor="Receita"
                       
                    />
                    <div className="right-section right-section-processo">
                        <div className="row top-serch">
                        {this.state.parsed ? (
                                <div
                                    className="col-12 pl-2 pr-2"
                                    id="ClienteReceita"
                                >
                                    <div className="head">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Cliente"
                                            )}
                                        </h2>
                                        <br></br>
                                        <p className="font-14"></p>
                                        
                                        {
                                    <div className="col-md-12">
                          
                                    <div className="input-box active-grey" id="SearchEntidadeBox">
                                        <span>Entidade</span>
                                        <Select
                                        showSearch
                                        onSearch={(e) => this.searchEntidade(e)}
                                        optionFilterProp="children"
                                        // maxTagTextLength={ 3 }
                                        placeholder="Selecione a entidade"
                                        className="mov-Ent-Select DropEntidade"
                                        //value={this.state.data.idTipoFormulario}
                                        onChange={(e) => this.handleChangeEntidade(e)}
                                        style={{ width: "100%"}}
                                        >
                                        <Option disabled >Selecione a entidade destino</Option>
                                        {(this.state.entidades && !!this.state.entidades.length) && this.state.entidades.map((item, index) => (
                                            <Option key={index} value={item.codEntidade}>{item.nome + " - " + item.nif} </Option>
                                          
                                        ))}
                                        </Select>
                                    </div>
                                    <div id="EntidadeDiv">
                                    <span>Entidade</span>
                                    <p id="entidadeNameDetails"></p>
                                    </div>
                                    </div>
                                   }
                                    </div>
                                </div>
                            ) : (
                                <>
                                    
                                </>
                            )}
                            {this.state.parsed ? (
                                <div
                                    className="bg-white middle p20"
                                    id="DetalhesFatura"
                                >
                                    <div className="head mb-0">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Detalhes do Documento"
                                            )}
                                        </h2>
                                        <br></br>
                                        <p className="font-14"></p>
                                        
                                        <div className="row">
                                        
                                            <div className="col-md-6">
                                                <div className="input-box active-grey drop-down-box">
                                               
                                                    <label className="input-label" style={{top: "-11px"}}>Tipo de Documento</label>
                                                    <select className="custome-drop-down" name="TipoDocumento" id="TipoDocumento">
                                                        <option value="">Selecione...</option>
                                                    </select>
                                                </div> 
                                                
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input-box active-grey drop-down-box">
                                                    <label className="input-label" style={{top: "-11px"}}>Tipo de Pagamento</label>
                                                    <select className="custome-drop-down" name="TipoPagamento" id="TipoPagamento">
                                                        <option value="">Selecione...</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-3">
                                                <span className="deadlineclenderlable EmissaoReceita">Data de Emissão</span>
                                                <div className="input-box active-grey">
                                                <DatePicker
                                                    value = {new Date}
                                                    className="form-control deadlineclender input-1 date_emissao_receita"
                                                    size="middle"
                                                    placeholder="Data de Emissão"
                                                    label="Data de Emissão"
                                                    name="date_emissao_receita"
                                                    id="date_emissao_receita"
                                                    disabled
                                                />   
                                                </div>      
                                            </div>
                                            <div className="col-3">
                                                <span className="deadlineclenderlable EmissaoReceita">Data Limite de Pagamento</span>
                                                <div className="input-box active-grey">
                                                <DatePicker
                                                    // value = {new Date}
                                                    className="form-control deadlineclender input-1 date_limite_receita"
                                                    size="middle"
                                                    placeholder="Data Limite de Pagamento"
                                                    label="Data Limite de Pagamento"
                                                    name="date_limite_receita"
                                                    id="date_limite_receita"
                                                    disabled= {DisableByDetail}
                                                />   
                                                </div>      
                                            </div>
                                            {/* <div className="col-md-12">
                                                <div className="input-box active-grey" style={{marginTop: "20px"}}>
                                                    <label className="input-label">Descrição/Observações</label>
                                                    <textarea name="DescricaoObs" className="form-control heigh-auto mt-2 DescricaoObs" rows="5"></textarea>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    
                                </>
                            )}
                            {this.state.estado === "Sob Análise" ? (
                                ""
                            ) : (
                                <div
                                    className="bg-white middle p20 position-relative"
                                    id="LinhasFatura"
                                >
                                    <div className="head position-relative mb-4">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Linhas do Documento"
                                            )}
                                        </h2>
                                    </div>
                                    <div className="row">
                                        <div className="col-12" id="emptyGrid">
                                            <CriacaoFatura
                                                date={new Date()}
                                                parsed={this.state.parsed}
                                                changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                                                linkData={this.state.linkData}
                                                trans_methods={this.state.trans_methods}
                                                data = {this.state.data}
                                            />
                                        </div>
                                        <div className="col-12" id="fillGrid">
                                            <TablePreenchida
                                                date={this.state.date}
                                                tableName="Tesouraria"
                                                applyedfilter={this.state.applyedfilter}
                                                ActionPerform={(action, row) => this.ActionPerform(action, row)}
                                            />
                                        </div>        
                                        
                                        {/* <div className="col-12">
                                            <h1 className="Sumario_receita">Sumário</h1>
                                            <div className="col-1">
                                                <p>Subtotal:</p>
                                                <p>IVA:</p>
                                                <p>Total:</p>
                                            </div>
                                            <div className="col-6">
                                               <p className="Subtotal_Sumario"></p> 
                                               <p className="Iva_Sumario"></p> 
                                               <p className="Total_Sumario"></p> 
                                            </div>
                                        </div> */}
                                    <div className="col-6 pt-4 offset-6">
                                        <div className="card">
                                            <div className="card-header">
                                            Sumário
                                            </div>
                                            <ul className="list-group list-group-flush">
                                                <li className="list-group-item d-flex justify-content-between align-items-center list-group-item-action">Subtotal:<span className="Subtotal">0,00</span></li>
                                                <li className="list-group-item d-flex justify-content-between align-items-center list-group-item-action">IVA:<span className="IvaReceita">0,00</span></li>
                                                <li className="list-group-item d-flex justify-content-between align-items-center list-group-item-action">Total:<span className="totalReceita">0,00</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                        
                                    </div>
                                </div>
                            )}
                             {this.state.estado === "Sob Análise" ? (
                                ""
                            ) : (
                                <div
                                    className="bg-white middle p20 position-relative"
                                    id="ObservacoesFatura"
                                >
                                    <div className="head position-relative mb-4">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Descrição/Observações"
                                            )}
                                        </h2>
                                    </div>
                                    <div className="row">
                                         <div className="col-md-12">
                                                <div className="input-box active-grey" style={{marginTop: "20px"}}>
                                                    <label className="input-label">Descrição/Observações</label>
                                                    <textarea name="DescricaoObs" className="form-control heigh-auto mt-2 DescricaoObs" rows="5"></textarea>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            )}
                            {this.state.invoice === null ? (
                                ""
                            ) : (
                                <div
                                    className="bg-white middle p20 position-relative"
                                    id="FaturaPDF"
                                >
                                    <div className="head position-relative mb-4">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Fatura"
                                            )}
                                        </h2>
                                    </div>
                                    <div className="row">
                                         <div className="col-md-12">
                                                <div className="input-box active-grey" style={{marginTop: "20px"}}>
                                                    {/* <label className="input-label">Ver documento</label> */}
                                                    <button className="k-button k-primary btn-ivdp-primary mr-2 btn-sm" type="button" title="Ver documento" onClick={(e) => this.displayPDF(e)}>Ver Documento</button>                                             
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CriacaoReceita;
